import React, { useState } from "react";
import { CModal, CModalBody } from "@coreui/react";
import { useDispatch } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg";
import placeholderImage from "../../../components/assets/image/placeholder.png";
import "../../../components/common/styles/createAdmin.css";
import { hideAddDealerModal, showAddDealerModal } from "../../../redux/actionDispatcher/admin/dealerModalDispatcher";
import { addDealerRequest } from "../../../redux/actionDispatcher/admin/dealerListingDispatcher";
import "./AddDealer.css";
import CountryCodeDropdown from "../../common/countryCodeDropdown";
import { imageBaseUrls } from "../../../constant/ApiUrls";
import AddressInput from "./AddressInput";
import Select from "react-select";
import Cropper from "react-easy-crop";
//  import { addDealerRequest } from "../redux/dealerDispatcher"; // 🔹 create dispatcher similar to category
const DAYS = [
  "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
];

const locations = [
  {
    "id": 1,
    "name": "Abbeylands"
  },
  {
    "id": 2,
    "name": "Andreas"
  },
  {
    "id": 3,
    "name": "Arbory"
  },
  {
    "id": 4,
    "name": "Baldrine"
  },
  {
    "id": 5,
    "name": "Baldrine (Balley Drine)"
  },
  {
    "id": 6,
    "name": "Baldwin"
  },
  {
    "id": 7,
    "name": "Ballabeg"
  },
  {
    "id": 8,
    "name": "Ballabeg (Lonan)"
  },
  {
    "id": 9,
    "name": "Ballabeg (Rushen)"
  },
  {
    "id": 10,
    "name": "Ballasalla"
  },
  {
    "id": 11,
    "name": "Ballaugh"
  },
  {
    "id": 12,
    "name": "Barregarrow"
  },
  {
    "id": 13,
    "name": "Braaid"
  },
  {
    "id": 14,
    "name": "Bradda"
  },
  {
    "id": 15,
    "name": "Braddan"
  },
  {
    "id": 16,
    "name": "Bride"
  },
  {
    "id": 17,
    "name": "Castletown"
  },
  {
    "id": 18,
    "name": "Colby"
  },
  {
    "id": 19,
    "name": "Cregneash"
  },
  {
    "id": 20,
    "name": "Crosby"
  },
  {
    "id": 21,
    "name": "Dalby"
  },
  {
    "id": 22,
    "name": "Derbyhaven"
  },
  {
    "id": 23,
    "name": "Douglas"
  },
  {
    "id": 24,
    "name": "Foxdale"
  },
  {
    "id": 25,
    "name": "German"
  },
  {
    "id": 26,
    "name": "Glen Auldyn"
  },
  {
    "id": 27,
    "name": "Glen Helen"
  },
  {
    "id": 28,
    "name": "Glen Maye"
  },
  {
    "id": 29,
    "name": "Glen Vine"
  },
  {
    "id": 30,
    "name": "Gleneedle"
  },
  {
    "id": 31,
    "name": "Greeba"
  },
  {
    "id": 32,
    "name": "Injebreck"
  },
  {
    "id": 33,
    "name": "Jurby"
  },
  {
    "id": 34,
    "name": "Kirk Michael"
  },
  {
    "id": 35,
    "name": "Laxey"
  },
  {
    "id": 36,
    "name": "Lezayre"
  },
  {
    "id": 37,
    "name": "Lonan"
  },
  {
    "id": 38,
    "name": "Malew"
  },
  {
    "id": 39,
    "name": "Maughold"
  },
  {
    "id": 40,
    "name": "Newtown"
  },
  {
    "id": 41,
    "name": "Niarbyl"
  },
  {
    "id": 42,
    "name": "Onchan"
  },
  {
    "id": 43,
    "name": "Patrick"
  },
  {
    "id": 44,
    "name": "Peel"
  },
  {
    "id": 45,
    "name": "Port e Vullen"
  },
  {
    "id": 46,
    "name": "Port Erin"
  },
  {
    "id": 47,
    "name": "Port Soderick"
  },
  {
    "id": 48,
    "name": "Port St Mary"
  },
  {
    "id": 49,
    "name": "Ramsey"
  },
  {
    "id": 50,
    "name": "Ronague"
  },
  {
    "id": 51,
    "name": "Rushen"
  },
  {
    "id": 52,
    "name": "Sandygate"
  },
  {
    "id": 53,
    "name": "Santon"
  },
  {
    "id": 54,
    "name": "St John's"
  },
  {
    "id": 55,
    "name": "St Judes"
  },
  {
    "id": 56,
    "name": "St Marks"
  },
  {
    "id": 57,
    "name": "Strang"
  },
  {
    "id": 58,
    "name": "Sulby"
  },
  {
    "id": 59,
    "name": "Union Mills"
  }
];

const allSalesMode = [
  {
    value: "Classic",
    label: "Classic",
    image: "/preview_one.jpg"
  },
  {
    value: "Spec and Options",
    label: "Spec and Options",
    image: "/preview_two.jpg"
  },
  {
    value: "Simple with finance",
    label: "Simple with finance",
    image: "/preview_three.jpg"
  }
];
const AddDealer = ({ editMode = false, dealerData = {}, tierList = [], allMake = [] }) => {

  const allMakeOptions = [
    { label: "Select All", value: "__all__" },
    ...allMake
  ];

  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.6)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999
    },
    modal: {
      position: "relative",
      width: 350,
      background: "#fff",
      borderRadius: 10,
      padding: 20,
      boxShadow: "0 5px 20px rgba(0,0,0,0.3)"
    },
    closeBtn: {
      position: "absolute",
      top: 10,
      right: 10,
      cursor: "pointer",
      fontSize: 18,
      fontWeight: "bold"
    },
    doneBtn: {
      marginTop: 15,
      width: "100%",
      padding: 10,
      background: "#007bff",
      color: "#fff",
      border: "none",
      borderRadius: 5,
      cursor: "pointer"
    }
  };





  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);


  console.log("FJFHJFHJFHJ::::::::", allSalesMode.find(item => item.value === dealerData?.silent_mode));
  // Dealer fields
  const [businessName, setBusinessName] = useState(dealerData?.business_name ?? "");
  const [email, setEmail] = useState(dealerData?.email ?? "");
  const [phone, setPhone] = useState(dealerData?.number ?? "");
  const [website, setWebsite] = useState(dealerData?.website ?? "");
  const [name, setName] = useState(dealerData?.name ?? "");
  const [country, setCountry] = useState("Isle of Man");
  const [locationId, setLocationId] = useState(dealerData?.location_id ?? "");
  const [location, setLocation] = useState(dealerData?.location ?? "");

  const [address, setAddress] = useState(dealerData?.business_address ?? "");
  const [suggestions, setSuggestions] = useState([]);
  const [placeId, setPlaceId] = useState(dealerData?.review_id ?? "");


  const [about, setAbout] = useState(dealerData?.about ?? "");
  const [countryCode, setCountryCode] = useState(null);
  const [primarySector, setPrimarySector] = useState(
    dealerData?.primary_sector ? dealerData.primary_sector.split(",") : []
  );



  const getInitialMake = () => {
    if (!dealerData?.make) return [];

    const selected = dealerData.make.split(","); // ["Honda","Hyundai"]
    const all = allMake.map(o => o.value); // ["Honda","Hyundai",...]

    const isAllSelected =
      selected.length === all.length &&
      all.every(val => selected.includes(val));

    return isAllSelected ? ["__all__"] : selected;
  };




  const [make, setMake] = useState(
    getInitialMake()
  );

  const [emailContact, setEmailContact] = useState(dealerData?.email_contact ?? "");
  const [phoneContact, setPhoneContact] = useState(dealerData?.phone_contact ?? "");
  const [whatsaapContact, setWhatsappContact] = useState(dealerData?.whatsaap_contact ?? "");
  // const [reviewId, setReviewId] = useState(dealerData?.review_id ?? "");
  const [dealerStatus, setDealerStatus] = useState(dealerData?.dealer_status ?? 1);


  const [selectedTier, setSelectedTier] = useState(dealerData?.new_tier_id ?? null);

  // Profile image
  const [profileImage, setProfileImage] = useState(dealerData?.image != null ? imageBaseUrls(dealerData?.image) : null);
  const [uploadProfileImage, setUploadProfileImage] = useState(null);



  // Background image
  const [backgroundImage, setBackgroundImage] = useState(dealerData?.bg_image != null ? imageBaseUrls(dealerData?.bg_image) : null);
  const [uploadBackgroundImage, setUploadBackgroundImage] = useState(null);



  // Logo image
  const [logoImage, setLogoImage] = useState(dealerData?.logo != null ? imageBaseUrls(dealerData?.logo) : null);
  const [uploadLogoImage, setUploadLogoImage] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  // Errors
  const [errors, setErrors] = useState({});



  const [loading, setLoading] = useState(false);
  const [silentSalesMode, setSilentSalesMode] = useState(
    dealerData?.silent_mode
      ? allSalesMode.find(item => item.value === dealerData?.silent_mode)
      : null
  );
  // Opening hours
  const [openingHours, setOpeningHours] = useState(
    DAYS.map((day) => ({
      day,
      open: "09:00",
      close: "18:00",
      closed: false,
    }))
  );





  const resetForm = () => {


    setImageSrc(null);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedAreaPixels(null);
    setShowCropper(false);
    setBusinessName("");
    setEmail("");
    setPhone("");
    setWebsite("");
    setPrimarySector([]);
    setName("");
    setCountry("Isle of Man"); // keep default
    setCountryCode(null);      // reset dropdown too
    setLocation("");
    setLocationId("");
    setAddress("");
    setSuggestions([]);
    setPlaceId("");
    setAbout("");
    setProfileImage(null);
    setUploadProfileImage(null);
    setUploadLogoImage(null);
    setLogoImage(null);
    setUploadBackgroundImage(null);
    setBackgroundImage(null);
    setErrors({});
    setEmailContact("");
    setPhoneContact("");
    setWhatsappContact("");
    setDealerStatus(1);
    setLoading(false);
    setMake([]);
    setSilentSalesMode(null);
    setOpeningHours(
      DAYS.map((day) => ({
        day,
        open: "09:00",
        close: "18:00",
        closed: false,
      }))
    );
  };

  const handleHoursChange = (index, key, value) => {
    const updated = [...openingHours];
    updated[index][key] = value;
    setOpeningHours(updated);
  };

  const handleProfileImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const validTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!validTypes.includes(file.type)) {
      alert("Please select a valid image file (JPEG, PNG, JPG)");
      return;
    }
    const imageUrl = URL.createObjectURL(file);
    setProfileImage(imageUrl);
    setUploadProfileImage(file);
  };



  const handleBackgroundImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const validTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!validTypes.includes(file.type)) {
      alert("Please select a valid image file (JPEG, PNG, JPG)");
      return;
    }
    const imageUrl = URL.createObjectURL(file);
    setBackgroundImage(imageUrl);
    setUploadBackgroundImage(file);
  };


  // const handleLogoImageChange = (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;
  //   const validTypes = ["image/jpeg", "image/png", "image/jpg"];
  //   if (!validTypes.includes(file.type)) {
  //     alert("Please select a valid image file (JPEG, PNG, JPG)");
  //     return;
  //   }
  //   const imageUrl = URL.createObjectURL(file);
  //   setLogoImage(imageUrl);
  //   setUploadLogoImage(file);
  // };


  const handleLogoImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!validTypes.includes(file.type)) {
      alert("Please select a valid image file (JPEG, PNG, JPG)");
      return;
    }

    const imageUrl = URL.createObjectURL(file);

    // 👉 Instead of directly setting image
    setImageSrc(imageUrl); // open cropper
    setShowCropper(true);
  };




  const handleCropSave = async () => {
    const croppedFile = await getCroppedImg();

    // ✅ same as your original logic
    setUploadLogoImage(croppedFile);
    setLogoImage(URL.createObjectURL(croppedFile));

    setImageSrc(null); // close cropper
  };



  const getCroppedImg = async () => {
    const image = new Image();
    image.src = imageSrc;

    await new Promise((resolve) => (image.onload = resolve));

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = croppedAreaPixels.width;
    canvas.height = croppedAreaPixels.height;

    ctx.drawImage(
      image,
      croppedAreaPixels.x,
      croppedAreaPixels.y,
      croppedAreaPixels.width,
      croppedAreaPixels.height,
      0,
      0,
      croppedAreaPixels.width,
      croppedAreaPixels.height
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        const file = new File([blob], "logo.png", { type: "image/png" });
        resolve(file);
      }, "image/png");
    });
  };

  const capitalizeWords = (value) => {
    return value
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };




  const validate = (key = null, value = null) => {
    let newErrors = { ...errors }; // keep old errors

    // Helper to get latest value
    const getValue = (field, stateValue) => {
      return key === field ? value : stateValue;
    };

    const aboutValue = getValue("about", about);
    const businessNameValue = getValue("businessName", businessName);
    const emailValue = getValue("email", email);
    const phoneValue = getValue("phone", phone);
    const websiteValue = getValue("website", website);
    const nameValue = getValue("name", name);
    const countryValue = getValue("country", country);
    const addressValue = getValue("address", address);

    const phoneContactValue = getValue("phoneContact", phoneContact);

    const emailContactValue = getValue("emailContact", emailContact);

    const whatsaapContactValue = getValue("whatsaapContact", whatsaapContact);
    const selectedTierValue = getValue("selectedTier", selectedTier);
    const silentSalesModeValue = getValue("silent_mode", silentSalesMode);
    const makeValue = getValue("make", make);
    const primarySectorValue = getValue("primarySector", primarySector);

    // 👉 If specific field validation
    if (key) {
      delete newErrors[key]; // clear previous error for this field

      switch (key) {
        case "about":
          if (!aboutValue.trim()) newErrors.about = "About is required";
          break;

        case "businessName":
          if (!businessNameValue.trim()) newErrors.businessName = "Business name is required";
          break;

        case "email":
          if (!emailValue.trim()) newErrors.email = "Email is required";
          break;

        case "phone":
          if (!phoneValue.trim()) newErrors.phone = "Phone number is required";
          break;

        case "website":
          if (!websiteValue.trim()) newErrors.website = "Website is required";
          break;

        case "name":
          if (!nameValue.trim()) newErrors.name = "Contact person name is required";
          break;

        case "country":
          if (!countryValue.trim()) newErrors.country = "Country is required";
          break;


        case "phoneContact":
          if (!phoneContactValue.trim()) newErrors.phoneContact = "Please select phone contact";
          break;

        case "emailContact":
          if (!emailContactValue.trim()) newErrors.emailContact = "Please select email contact";
          break;

        case "whatsaapContact":
          if (!whatsaapContactValue.trim()) newErrors.whatsaapContact = "Please select whatsaap contact";
          break;

        case "selectedTier":
          if (!selectedTierValue.trim()) newErrors.selectedTier = "Please select tier";
          break;

        case "silent_mode":
          if (!silentSalesModeValue) newErrors.silent_mode = "Please select silent salesman mode";
          break;

        case "make":
          if (makeValue.length === 0) newErrors.make = "Please select make";
          break;

        case "primarySector":
          if (primarySectorValue.length === 0) newErrors.primarySector = "Please select primary sector";
          break;



        case "address":
          if (!addressValue.trim()) {
            newErrors.address = "Address is required";
          }
          // else if (!placeId) {
          //   newErrors.address = "Please select address from suggestions";
          // }
          break;

        default:
          break;
      }

      setErrors(newErrors);
      return;
    }

    // 👉 Full validation (on submit)
    newErrors = {};

    if (!businessName.trim()) newErrors.businessName = "Business name is required";
    if (!email.trim()) newErrors.email = "Email is required";
    if (!phone.trim()) newErrors.phone = "Phone number is required";
    if (!website.trim()) newErrors.website = "Website is required";
    if (!name.trim()) newErrors.name = "Contact person name is required";
    if (!country.trim()) newErrors.country = "Country is required";
    if (!countryCode) newErrors.countryCode = "Country code is required";
    if (!locationId) newErrors.locationId = "Location is required";

    if (!address.trim()) {
      newErrors.address = "Address is required";
    } else if (!placeId) {
      newErrors.address = "Please select address from suggestions";
    }

    if (!silentSalesMode) newErrors.silent_mode = "Please select silent salesman mode";
    if (!about.trim()) newErrors.about = "About is required";
    if (!selectedTier) newErrors.selectedTier = "Please select tier";
    if (!whatsaapContact) newErrors.whatsaapContact = "Please select whatsaap contact";
    if (!phoneContact) newErrors.phoneContact = "Please select phone contact";
    if (!emailContact) newErrors.emailContact = "Please select email contact";

    if (primarySector.length === 0) {
      newErrors.primarySector = "Please select primary sector";
    } else {
      if (primarySector.includes("Motors") && !dealerStatus) {
        newErrors.dealerStatus = "Please select dealer type";
      }

      if (
        primarySector.includes("Motors") &&
        dealerStatus === 1 &&
        make.length === 0
      ) {
        newErrors.make = "Please select make";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    const data = {
      business_name: businessName,       // DB: business_name
      flag: countryCode.v.replace('+', ''), // DB: flag
      country_code: countryCode.cc,      // DB: country_code
      number: phone,                     // DB: number
      email,                             // DB: email
      website,                           // DB: (no field → new table/ignore OR add to business_address text)
      name,                              // DB: name
      country,                           // DB: country
      location_id: locationId,           // DB: location_id
      location,                          // DB: location
      address,                           // DB: business_address
      about,                             // DB: (no direct column → need dealer_details table or use business_address/extra column)
      opening_hours: openingHours,       // DB: separate table opening_hours (FK = user_id)
      image: uploadProfileImage, // DB: image

      vendor_type: "dealer",             // DB: vendor_type   // DB: password
      required_change_password: 1,       // DB: (⚠️ missing in your table → you need to add column tinyint default 0)
      primary_sector: primarySector.join(","), // 🔹 added
      tier_id: selectedTier,
      review_id: placeId,
      whatsaap_contact: whatsaapContact,
      email_contact: emailContact,
      phone_contact: phoneContact,
      silent_mode: silentSalesMode.value,
    };



    if (primarySector.includes("Motors")) {
      data.dealer_status = dealerStatus;

      if (dealerStatus === 1) {
        data.make = make.includes("__all__")
          ? allMake
            .map((opt) => opt.value)
            .join(",")
          : make.join(",");
      }
    }




    if (uploadBackgroundImage) {
      data.bg_image = uploadBackgroundImage;
    }


    if (uploadLogoImage) {
      data.logo = uploadLogoImage
    }

    if (editMode) {
      data.id = dealerData.id;
    }

    console.log("Payload 👉", data);


    setLoading(true);

    const result = await dispatch(addDealerRequest(data));
    setLoading(false);

    if (result) {
      if (!editMode) resetForm();
      setIsModalVisible(false);
      dispatch(hideAddDealerModal());
    }

  };

  const handleClose = () => {
    setIsModalVisible(false);
    dispatch(hideAddDealerModal());
  };


  const handleMakeChange = (selectedOptions) => {
    if (!selectedOptions || selectedOptions.length === 0) {
      setMake([]);
      return;
    }

    const last = selectedOptions[selectedOptions.length - 1];

    // 👉 If "Select All" clicked
    if (last.value === "__all__") {
      setMake(["__all__"]); // ✅ ONLY ALL
      return;
    }

    // 👉 If user selects anything else → remove "__all__"
    const filtered = selectedOptions
      .filter(opt => opt.value !== "__all__")
      .map(opt => opt.value);

    setMake(filtered);
  };


  return (
    <div>
      {/* Open Button */}
      <button
        onClick={() => {
          if (!editMode) resetForm();
          setIsModalVisible(true);
          dispatch(showAddDealerModal());
        }}
        style={{
          backgroundColor: editMode ? "#1b87f4" : "rgb(0 0 0)",
          color: "white",
          border: "none",
          cursor: "pointer",
          borderRadius: "4px",
          fontSize: editMode ? "10px" : "14px",
          minWidth: "60px",
          height: editMode ? "24px" : "30px",
          padding: editMode ? "2px 5px" : "4px 10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {editMode ? "Edit Dealer" : "Add Dealer"}
      </button>

      {/* Modal */}
      <CModal
        alignment="center"
        visible={isModalVisible}
        onClose={handleClose}
        className="attributemodal"
      >
        <CModalBody className="main-container createAdmin">
          <div style={{ maxWidth: 920, padding: "0 20px" }}>
            <div className="cross-btn-div d-flex" style={{ justifyContent: "space-between", minWidth: "100%" }}>
              <h4
                className="h3 fw-bold mb-3 mt-2"
                style={{ color: "#007bff", textAlign: "center" }}
              >
                {editMode ? "Edit Dealer" : "Add New Dealer"}
              </h4>
              <img
                onClick={handleClose}
                src={crossButton}
                alt="close"
                className="cross-button"
                style={{ cursor: "pointer" }}
              />
            </div>

            <form onSubmit={(e) => e.preventDefault()}>
              {/* Profile image */}
              <div style={{ display: "flex", gap: 16, alignItems: "flex-start", marginBottom: 12 }}>
                <div style={{ minWidth: 140, textAlign: "center" }}>
                  <div
                    style={{
                      marginBottom: 10,
                      marginTop: 0,
                      fontSize: "14px",
                      fontWeight: 500
                    }}
                  >
                    Profile Image
                  </div>

                  <input
                    type="file"
                    accept="image/*"
                    id="profileImageUpload"
                    style={{ display: "none" }}
                    onChange={handleProfileImageChange}
                  />

                  {/* Image Wrapper */}
                  <div style={{ position: "relative", display: "inline-block" }}>
                    <img
                      onClick={() =>
                        document.getElementById("profileImageUpload").click()
                      }
                      src={profileImage || placeholderImage}
                      alt="Profile Preview"
                      style={{
                        height: 120,
                        width: 120,
                        borderRadius: 8,
                        objectFit: "cover",
                        cursor: "pointer",
                        border: "1px solid #ddd"
                      }}
                      title="Click to upload profile image"
                    />

                    {/* ❌ Cross Button */}
                    {profileImage && (
                      <span
                        onClick={() => {
                          setProfileImage(null);
                          setUploadProfileImage(null);
                          document.getElementById("profileImageUpload").value = "";
                        }}
                        style={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          background: "#fff",
                          borderRadius: "50%",
                          width: 20,
                          height: 20,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          border: "1px solid #ccc",
                          fontSize: 12,
                          fontWeight: "bold"
                        }}
                      >
                        ✕
                      </span>
                    )}
                  </div>

                  {errors.profileImage && (
                    <div
                      className="text-danger mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      {errors.profileImage}
                    </div>
                  )}
                </div>





                <div style={{ flex: 1 }}>

                  {/* Business Name */}
                  <label
                    className="form-label"
                    style={{ fontSize: "12px", marginBottom: "2px", display: "block" }}
                  >
                    Business Name
                  </label>

                  <input
                    className="form-control"
                    style={{ marginTop: 0 }}
                    placeholder="Please enter business name"
                    autofill="off"
                    autoComplete="new-password"   // ✅ best trick for Chrome

                    value={businessName}
                    onChange={(e) => {
                      const value = e.target.value;
                      setBusinessName(value);
                      validate("businessName", value);
                    }}
                  />
                  {errors.businessName && (
                    <div className="text-danger" style={{ fontSize: "12px" }}>
                      {errors.businessName}
                    </div>
                  )}

                  {/* Email + Phone Row */}
                  <div style={{ display: "flex", gap: 12, alignItems: "flex-start", marginTop: 10 }}>

                    {/* Email */}
                    <div style={{ flex: 1 }}>
                      <label
                        className="form-label"
                        style={{ fontSize: "12px", marginBottom: "2px", display: "block" }}
                      >
                        Business Email
                      </label>

                      <input
                        className="form-control"
                        style={{ marginTop: 0 }}
                        autofill="off"
                        autoComplete="new-password"   // ✅ best trick for Chrome

                        placeholder="Please enter business email"
                        value={email}
                        type="email"
                        onChange={(e) => {
                          const value = e.target.value;
                          setEmail(value);
                          validate("email", value);


                        }}
                      />
                      {errors.email && (
                        <div className="text-danger" style={{ fontSize: "12px" }}>
                          {errors.email}
                        </div>
                      )}
                    </div>

                    {/* Country Code */}
                    <div style={{ marginTop: 18 }}>
                      <CountryCodeDropdown
                        height={38}
                        onChange={setCountryCode}
                        value={
                          countryCode != null
                            ? countryCode.cc
                            : dealerData?.country_code ?? null
                        }
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <label
                        className="form-label"
                        style={{ fontSize: "12px", marginBottom: "2px", display: "block" }}
                      >
                        Business Phone Number
                      </label>

                      <input
                        type="tel"
                        className="form-control"
                        autofill="off"
                        autoComplete="new-password"   // ✅ best trick for Chrome

                        style={{ width: 200, marginTop: 0 }}
                        placeholder="Please enter phone number"
                        value={phone}
                        onChange={(e) => {
                          const val = e.target.value.replace(/\D/g, "");

                          setPhone(val);
                          validate("phone", val);

                        }}
                      />
                      {errors.phone && (
                        <div className="text-danger" style={{ fontSize: "12px" }}>
                          {errors.phone}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Website + Contact Person Row */}
                  <div style={{ display: "flex", gap: 12, alignItems: "flex-start", marginTop: 10 }}>

                    {/* Website */}
                    <div style={{ flex: 1 }}>
                      <label
                        className="form-label"
                        style={{ fontSize: "12px", marginBottom: "2px", display: "block" }}
                      >
                        Dealer Website
                      </label>
                      <input
                        className="form-control"
                        placeholder="Please enter dealer website link"
                        value={website}
                        autoComplete="new-password"
                        onChange={(e) => {

                          const value = e.target.value;
                          setWebsite(value);
                          validate("website", value);
                        }}
                      />
                      {errors.website && (
                        <div className="text-danger" style={{ fontSize: "12px" }}>
                          {errors.website}
                        </div>
                      )}
                    </div>

                    {/* Contact Person */}
                    <div>
                      {/* Business Name */}
                      <label
                        className="form-label"
                        style={{ fontSize: "12px", marginBottom: "2px", display: "block" }}
                      >
                        Contact Person Name
                      </label>
                      <input
                        className="form-control"
                        style={{ width: 220 }}
                        placeholder="Please enter contact person name"
                        value={name}
                        autoComplete="new-password"
                        onChange={(e) => {

                          const value = capitalizeWords(e.target.value);
                          setName(value);
                          validate("name", value);

                        }}
                      />
                      {errors.name && (
                        <div className="text-danger" style={{ fontSize: "12px" }}>
                          {errors.name}
                        </div>
                      )}
                    </div>
                  </div>

                </div>








              </div>
              <div style={{ display: "flex", gap: 16, alignItems: "flex-start", marginBottom: 12 }}>
                <div style={{ minWidth: 140, textAlign: "center" }}>
                  <div
                    style={{
                      marginBottom: 10,
                      marginTop: 0,
                      fontSize: "14px",
                      fontWeight: 500
                    }}
                  >
                    Background Image
                  </div>

                  <input
                    type="file"
                    accept="image/*"
                    id="backgroundImageUpload"
                    style={{ display: "none" }}
                    onChange={handleBackgroundImageChange}
                  />

                  {/* Image Wrapper */}
                  <div style={{ position: "relative", display: "inline-block" }}>
                    <img
                      onClick={() =>
                        document.getElementById("backgroundImageUpload").click()
                      }
                      src={backgroundImage || placeholderImage}
                      alt="Background Preview"
                      style={{
                        height: 120,
                        width: 120,
                        borderRadius: 8,
                        objectFit: "cover",
                        cursor: "pointer",
                        border: "1px solid #ddd"
                      }}
                      title="Click to upload background image"
                    />

                    {/* ❌ Cross Button */}
                    {backgroundImage && (
                      <span
                        onClick={() => {
                          setBackgroundImage(null);
                          setUploadBackgroundImage(null);

                          document.getElementById("backgroundImageUpload").value = "";
                        }}
                        style={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          background: "#fff",
                          borderRadius: "50%",
                          width: 20,
                          height: 20,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          border: "1px solid #ccc",
                          fontSize: 12,
                          fontWeight: "bold"
                        }}
                      >
                        ✕
                      </span>
                    )}
                  </div>

                  {errors.backgroundImage && (
                    <div
                      className="text-danger mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      {errors.backgroundImage}
                    </div>
                  )}
                </div>

                <div style={{ flex: 1 }}>
                  {/* Primary Sector */}
                  <div className="mt-3 mb-3">  {/* added mb-3 for bottom spacing */}
                    <label className="form-label fw-bold">Primary Sectors</label>
                    <div style={{ display: "flex", gap: "16px", marginTop: 4 }}>
                      {["Motors", "Property", "Jobs", "Marketplace"].map((sector) => (
                        <label key={sector} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                          <input
                            type="checkbox"
                            value={sector}
                            checked={primarySector.includes(sector)}
                            onChange={(e) => {
                              console.log("FHJHFJHFJ:::::", e.target.checked);

                              if (e.target.checked) {
                                setPrimarySector([sector]);
                                validate("primarySector", [sector])
                                setSelectedTier(null);
                              } else {
                                setPrimarySector([]);
                                setSelectedTier(null);
                                validate("primarySector", [])


                              }
                            }}
                          />
                          {sector}
                        </label>
                      ))}
                    </div>
                    {errors.primarySector && <div className="text-danger" style={{ fontSize: "12px" }}>{errors.primarySector}</div>}

                  </div>

                  {
                    primarySector.includes("Motors") && <div className="mt-3 mb-3">
                      <label className="form-label fw-bold">Dealer Type</label>

                      <div style={{ display: "flex", gap: "18px", marginTop: 6 }}>
                        {[
                          { label: "Main Dealer", value: 1 },
                          { label: "Franchise Dealer", value: 2 },
                          // { label: "Independent Dealer", value: 3 }
                        ].map((item) => (
                          <label
                            key={item.value}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              fontSize: "14px",
                              cursor: "pointer"
                            }}
                          >
                            <input
                              type="radio"
                              name="dealer_status"
                              value={item.value}
                              checked={dealerStatus === item.value}
                              onChange={() => setDealerStatus(item.value)}
                              style={{
                                width: "14px",
                                height: "14px",
                                margin: 0,
                                accentColor: "#0d6efd" // optional (bootstrap blue)
                              }}
                            />
                            {item.label}
                          </label>
                        ))}
                      </div>
                      {errors.dealerStatus && <div className="text-danger" style={{ fontSize: "12px" }}>{errors.dealerStatus}</div>}

                    </div>
                  }




                  {
                    primarySector.includes("Motors") && dealerStatus === 1 && <div>
                      <label
                        className="form-label"
                        style={{ fontSize: "12px", marginBottom: "2px", display: "block" }}
                      >
                        Select make
                      </label>
                      <Select
                        options={make.includes("__all__")
                          ? [{ value: "__all__", label: "Select All" }] // only show ALL
                          : allMakeOptions}
                        isMulti={true}
                        value={allMakeOptions.filter(option =>
                          make.includes(option.value)
                        )}
                        onChange={handleMakeChange}
                        placeholder="Select Makes..."
                      />
                      {errors.make && <div className="text-danger" style={{ fontSize: "12px" }}>{errors.make}</div>}

                    </div>
                  }


                  <div>
                    <label
                      className="form-label"
                      style={{ fontSize: "12px", marginBottom: "2px", marginTop: "10px", display: "block" }}
                    >
                      Select silent sales man mode
                    </label>

                    <Select
                      options={allSalesMode}
                      value={silentSalesMode}
                      onChange={(v) => {
                        setSilentSalesMode(v);
                        validate('silent_mode', v)
                      }}
                      placeholder="Select silent sales man mode"
                      components={{
                        Option: (props) => (
                          <div
                            {...props.innerProps}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "8px"
                            }}
                          >
                            <img
                              src={props.data.image}
                              alt={props.data.label}
                              style={{
                                width: "px",
                                height: "250px",
                                objectFit: "cover",
                                marginRight: "10px",
                                borderRadius: "4px"
                              }}
                            />
                            {props.data.label}
                          </div>
                        ),


                      }}
                    />

                    {errors.silent_mode && (
                      <div className="text-danger" style={{ fontSize: "12px" }}>
                        {errors.silent_mode}
                      </div>
                    )}
                  </div>


                  {/* Country & Location */}
                  <div style={{ display: "flex", gap: 8, marginBottom: 8, marginTop: 10 }}>
                    <div>
                      <label
                        className="form-label"
                        style={{ fontSize: "12px", marginBottom: "0px", display: "block" }}
                      >
                        Select Country
                      </label>
                      <select
                        className="form-control mt-0"
                        value={country}
                        onChange={(e) => {
                          const value = e.target.value;
                          setCountry(value);
                          validate("country", value);

                        }}
                        style={{ width: 190 }}
                      >
                        <option value="Isle of Man">Isle of Man</option>
                      </select>
                      {errors.country && <div className="text-danger" style={{ fontSize: "12px" }}>{errors.country}</div>}
                    </div>

                    <div>
                      <label
                        className="form-label"
                        style={{ fontSize: "12px", marginBottom: "0px", display: "block" }}
                      >
                        Select Location
                      </label>
                      <select
                        className="form-control mt-0"
                        value={locationId}
                        onChange={(e) => {
                          const id = e.target.value;
                          setLocationId(id);
                          const loc = locations.find((l) => l.id === Number(id));

                          const value = loc?.name || "";
                          setLocation(value);
                          validate("locationId", value);



                        }}
                        style={{ width: 190 }}
                      >
                        <option value="">Select Location</option>
                        {locations.map((loc) => (
                          <option key={loc.id} value={loc.id}>
                            {loc.name}
                          </option>
                        ))}
                      </select>
                      {errors.locationId && <div className="text-danger" style={{ fontSize: "12px" }}>{errors.locationId}</div>}
                    </div>

                    <div className="mb-3">

                      <label
                        className="form-label"
                        style={{ fontSize: "12px", marginBottom: "0px", display: "block" }}
                      >
                        Select Tier
                      </label>

                      <select
                        className="form-control mt0"
                        value={selectedTier}
                        onChange={(e) => {

                          const val = e.target.value; // remove non-digits
                          setSelectedTier(val);
                          validate("selectedTier", val);


                        }}
                        style={{ width: 190 }}
                      >
                        <option value="">Select Tier</option>
                        {tierList
                          .filter((tier) => primarySector.includes(tier.sector))
                          .map((tier) => (
                            <option key={tier.id} value={tier.id}>
                              {tier.name}
                            </option>
                          ))}
                      </select>

                      {errors.selectedTier && <div className="text-danger" style={{ fontSize: "12px" }}>{errors.selectedTier}</div>}


                    </div>
                  </div>

                </div>
              </div>


              <div style={{ display: "flex", gap: 16, alignItems: "flex-start", marginBottom: 12 }}>
                <div style={{ minWidth: 140, textAlign: "center" }}>
                  <div
                    style={{
                      marginBottom: 10,
                      marginTop: 0,
                      fontSize: "14px",
                      fontWeight: 500
                    }}
                  >
                    Business Logo
                  </div>

                  <input
                    type="file"
                    accept="image/*"
                    id="logoImageUpload"
                    style={{ display: "none" }}
                    onChange={handleLogoImageChange}
                  />

                  {/* Image Wrapper */}
                  <div style={{ position: "relative", display: "inline-block" }}>
                    <img
                      onClick={() =>
                        document.getElementById("logoImageUpload").click()
                      }
                      src={logoImage || placeholderImage}
                      alt="Logo Preview"
                      style={{
                        height: 120,
                        width: 120,
                        borderRadius: 8,
                        objectFit: "cover",
                        cursor: "pointer",
                        border: "1px solid #ddd"
                      }}
                      title="Click to upload logo image"
                    />

                    {/* ❌ Cross Button */}
                    {logoImage && (
                      <span
                        onClick={() => {
                          setLogoImage(null);
                          setUploadLogoImage(null);

                          document.getElementById("logoImageUpload").value = "";
                        }}
                        style={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          background: "#fff",
                          borderRadius: "50%",
                          width: 20,
                          height: 20,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          border: "1px solid #ccc",
                          fontSize: 12,
                          fontWeight: "bold"
                        }}
                      >
                        ✕
                      </span>
                    )}
                  </div>

                  {showCropper && (
                    <div style={styles.overlay}>
                      <div style={styles.modal}>

                        {/* ❌ Close Button */}
                        <span
                          onClick={() => setShowCropper(false)}
                          style={styles.closeBtn}
                        >
                          ✕
                        </span>

                        {/* Cropper */}
                        <div style={{ position: "relative", width: "100%", height: 300 }}>
                          <Cropper
                            image={imageSrc}
                            crop={crop}
                            zoom={zoom}
                            aspect={1}
                            cropShape="rect"    // 🔥 change this
                            showGrid={true}
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={(croppedArea, croppedAreaPixels) => {
                              setCroppedAreaPixels(croppedAreaPixels);
                            }}
                          />
                        </div>

                        {/* ✅ Done Button */}
                        <button
                          onClick={async () => {
                            await handleCropSave();
                            setShowCropper(false);
                          }}
                          style={styles.doneBtn}
                        >
                          Done
                        </button>
                      </div>
                    </div>
                  )}

                  {errors.logoImage && (
                    <div
                      className="text-danger mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      {errors.logoImage}
                    </div>
                  )}
                </div>


                <div style={{ flex: 1 }}>



                  <div>

                    <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                      <div>
                        <label
                          className="form-label"
                          style={{ fontSize: "12px", marginBottom: "0px", display: "block" }}
                        >
                          Contact Phone
                        </label>
                        <input
                          type="tel"
                          className="form-control mt-0"
                          placeholder="Please enter number"
                          value={phoneContact}
                          autofill="off"
                          autoComplete="new-password"   // ✅ best trick for Chrome
                          onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, ""); // remove non-digits
                            setPhoneContact(val);
                            validate("phoneContact", val);
                          }}
                          style={{ width: 200 }}
                        />
                        {errors.phoneContact && <div className="text-danger" style={{ fontSize: "12px" }}>{errors.phoneContact}</div>}
                      </div>

                      <div>
                        <label
                          className="form-label"
                          style={{ fontSize: "12px", marginBottom: "0px", display: "block" }}
                        >
                          Contact Email
                        </label>
                        <input
                          type="email"
                          className="form-control mt-0"
                          placeholder="Please enter email"
                          value={emailContact}
                          autofill="off"
                          autoComplete="new-password"   // ✅ best trick for Chrome
                          onChange={(e) => {

                            const value = e.target.value;
                            setEmailContact(value);
                            validate("emailContact", value);
                          }}
                          style={{ width: 200 }}
                        />
                        {errors.emailContact && <div className="text-danger" style={{ fontSize: "12px" }}>{errors.emailContact}</div>}
                      </div>


                      <div>
                        <label
                          className="form-label"
                          style={{ fontSize: "12px", marginBottom: "0px", display: "block" }}
                        >
                          WhatsApp Contact
                        </label>
                        <input
                          type="tel"
                          className="form-control mt-0"
                          placeholder="Please enter number"
                          value={whatsaapContact}
                          autofill="off"
                          autoComplete="new-password"   // ✅ best trick for Chrome
                          onChange={(e) => {


                            const value = e.target.value.replace(/\D/g, ""); // remove non-digits
                            setWhatsappContact(value);
                            validate("whatsaapContact", value);

                          }}
                          style={{ width: 200 }}
                        />
                        {errors.whatsaapContact && <div className="text-danger" style={{ fontSize: "12px" }}>{errors.whatsaapContact}</div>}
                      </div>

                    </div>



                  </div>


                  <div>

                    <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                      {/* Address */}

                      {/* <div>

                        <input
                          className="form-control mt-2"
                          placeholder="Address"
                          value={address}
                          onChange={(e) => {
                            setAddress(e.target.value);
                            validate();
                          }}
                          style={{ width: 410 }}

                          autofill="off"
                          autoComplete="new-password"   // ✅ best trick for Chrome

                        />
                        {errors.address && <div className="text-danger" style={{ fontSize: "12px" }}>{errors.address}</div>}

                      </div> */}

                      <AddressInput
                        address={address}
                        setAddress={setAddress}
                        suggestions={suggestions}
                        setSuggestions={setSuggestions}
                        // placeId={placeId}
                        setPlaceId={setPlaceId}
                        errors={errors}
                        call={(addressValue, placeIdValue) => {
                          validate("address", addressValue);

                          // you can also use placeIdValue if needed
                        }}

                      />

                      {/* <div>
                        <input
                          type="text"
                          className="form-control mt-2"
                          placeholder="Google Review Cusotmer Id"
                          value={reviewId}
                          autofill="off"
                          autoComplete="new-password"   // ✅ best trick for Chrome
                          onChange={(e) => {
                            const val = e.target.value; // remove non-digits
                            setReviewId(val);
                            validate();
                          }}
                          style={{ width: 200 }}
                        />
                        {errors.reviewId && <div className="text-danger" style={{ fontSize: "12px" }}>{errors.reviewId}</div>}
                      </div> */}




                    </div>



                  </div>




                  {/* About */}
                  <label
                    className="form-label"
                    style={{ fontSize: "12px", marginBottom: "0px", display: "block" }}
                  >
                    About Dealer
                  </label>
                  <textarea
                    className="form-control mt-0"
                    placeholder="Please enter about dealer"
                    rows="3"
                    value={about}
                    onChange={(e) => {

                      const value = e.target.value;
                      setAbout(value);
                      validate("about", value);

                    }}
                  />
                  {errors.about && <div className="text-danger" style={{ fontSize: "12px" }}>{errors.about}</div>}



                </div>
              </div>

              {/* Primary Sector */}







              {/* Opening Hours */}
              <h6 className="fw-bold mt-3 text-center">Opening Hours</h6>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",

                }}
              >
                <div style={{
                  display: "grid",
                  gridTemplateColumns: "120px 140px 16px 140px 100px",
                  gap: "8px 12px",
                  alignItems: "center",
                  marginBottom: 8,
                  fontSize: 13,
                  color: "#555"
                }}>
                  <div style={{ fontWeight: 600 }}>Day</div>
                  <div style={{ fontWeight: 600 }}>Opens</div>
                  <div></div>
                  <div style={{ fontWeight: 600 }}>Closes</div>
                  <div style={{ fontWeight: 600 }}>Closed</div>
                </div>

                {openingHours.map((item, index) => (
                  <div
                    key={item.day}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "120px 140px 16px 140px 100px",
                      gap: "8px 12px",
                      alignItems: "center",
                      marginBottom: 6,
                    }}
                  >
                    <div style={{ paddingRight: 4 }}>{item.day}</div>
                    <input
                      type="time"
                      value={item.open}
                      disabled={item.closed}
                      onChange={(e) => handleHoursChange(index, "open", e.target.value)}
                      className="form-control"
                      style={{ maxWidth: "140px" }}
                    />
                    <div style={{ textAlign: "center" }}>to</div>
                    <input
                      type="time"
                      value={item.close}
                      disabled={item.closed}
                      onChange={(e) => handleHoursChange(index, "close", e.target.value)}
                      className="form-control"
                      style={{ maxWidth: "140px" }}
                    />
                    <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <input
                        type="checkbox"
                        checked={item.closed}
                        onChange={(e) =>
                          handleHoursChange(index, "closed", e.target.checked)
                        }
                      />
                      <span style={{ fontSize: 13 }}>Closed</span>
                    </label>
                  </div>
                ))}

              </div>



              <div className="text-center">
                <button
                  className="btn btn-lg btn-primary fw-bold text-light mt-3"
                  type="button"
                  onClick={handleSubmit}
                  disabled={loading}
                  style={{ minWidth: "180px" }}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Processing...
                    </>
                  ) : (
                    editMode ? "Update Dealer" : "Submit Dealer"
                  )}
                </button>
              </div>

              {/* <div className="text-center">
                <button
                  className="btn btn-lg btn-primary fw-bold text-light mt-3"
                  type="button"
                  onClick={handleSubmit}
                >
                  {editMode ? "Update Dealer" : "Submit Dealer"}
                </button>
              </div> */}
            </form>
          </div>
        </CModalBody>
      </CModal>
    </div>
  );
};

export default AddDealer;